import React from 'react';
import {components, type InputProps} from 'react-select';

import {type MultiselectOption} from 'common/multiselect';

type CustomInputProps = InputProps<MultiselectOption, true> & {
    selectProps: {
        label: string;
        menuIsOpen?: boolean;
        placeholder?: string;
        searchPlaceholder?: string;
    };
};

const MultiselectInput = (props: CustomInputProps) => {
    const {selectProps} = props;
    const placeholderText = selectProps?.menuIsOpen
        ? selectProps?.searchPlaceholder
            ? selectProps.searchPlaceholder
            : selectProps.placeholder?.toString()
        : selectProps?.placeholder?.toString();

    return <components.Input {...props} placeholder={placeholderText} />;
};

export default MultiselectInput;
